"use client";
import JcgCommentThread from "./JcgCommentThread";
import { useAdminStatus } from "@/hooks/useAdminStatus";
export const THREAD_COMMENTS_ANCHOR_ID = "comments";
interface ThreadCommentSectionProps {
  slug: string;
  emptyText?: string;
  requireSignIn?: boolean;
}
/** 오래된 순서의 대화·관리자 삭제·로그인 전용 쓰기 정책은 앱에서 결정한다. */
export default function ThreadCommentSection(props: ThreadCommentSectionProps) {
  const { isAdmin } = useAdminStatus();
  return (
    <JcgCommentThread
      {...props}
      anchorId={THREAD_COMMENTS_ANCHOR_ID}
      className="mt-4"
      truncateAfter={null}
      canModerate={isAdmin}
      pageSize={null}
      order="oldest"
    />
  );
}
